import { zeroPadding } from "./zeroPadding.js";
const pluralize = (count, words, options = {})=>{
    const { withZeroPad } = options;
    const cases = [
        2,
        0,
        1,
        1,
        1,
        2
    ];
    const formattedCount = Math.abs(count);
    const resultNumber = withZeroPad ? zeroPadding(count) : count;
    if (formattedCount - Math.floor(formattedCount)) return `${resultNumber} ${words[1]}`;
    return `${resultNumber} ${words[formattedCount % 100 > 4 && formattedCount % 100 < 20 ? 2 : cases[Math.min(formattedCount % 10, 5)]]}`;
};
export { pluralize };
